// Enum

enum TipoUnidadeAcademicaEnum {
  DEPARTAMENTO = 1,
  ESCOLA = 2,
  PROGRAMA_POS_GRADUACAO = 3,
  CENTRO = 4,
  UNIDADE_ACADEMICA_ESPECIFICA = 5,
  COORDENACAO_CURSO = 6,
  PRO_REITORIA = 7,
  PROGRAMA_RESIDENCIA_MEDICA = 9,
}

// Export

export default TipoUnidadeAcademicaEnum;
